<template>
  <div class="bg">
    <div id="part4" class="part4">
      <PartTitle title="第十届赛事回顾" width="40%" left="70px" />
      <div class="container">
        <div class="container-view">
          <div v-for="(item, index) in list" :key="index" class="item">
            <img :src="item.coverUrl" alt="" @click="handleShowDetail(item)">
            <div class="text">
              <p @click="handleShowDetail(item)">{{ item.title }}</p>
            </div>
            <div class="more" @click="handleShowDetail(item)">详情 ></div>
          </div>
        </div>
        <div class="moreBtn">
          <el-button
            class="button"
            type="primary"
            round
            @click="handleShowAll"
          >查看更多</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PartTitle from '../PartTitle.vue'

export default {
  components: {
    PartTitle
  },
  props: {},
  data () {
    return {
      list: []
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    handleShowDetail (item) {
      console.log(item)
      let routeUrl = this.$router.resolve({
        path: '/detail',
        query: { id: item.id }
      })
      window.open(routeUrl.href, '_blank')
    },
    getList () {
      // 赛事资讯
      var api =
        this.siteURL +
        '/actuator/article/selectArticleList?siteId=' +
        this.siteId +
        '&nameEn=Event News'
      this.axios.get(api, {}).then(response => {
        this.list = response.data.rows.splice(0, 5)
      })
    },
    handleShowAll () {
      this.$router.push({ path: '/pastReview' })
    }
  }
}
</script>

<style lang="scss" scoped>
.bg {
  background: url(~@/assets/images/homebg4.png);
  background-position: center;
  background-size: 100% 100%;
}
.part4 {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  width: 1140px;
  padding-top: 20px;
  .container {
    padding: 20px;
    background: linear-gradient(
      rgba(253, 254, 255, 0.49) 0%,
      rgba(255, 255, 255, 0.66) 100%
    );
    border-radius: 2px;
    margin: 20px 0;
    border: 2px solid #ffffff;

    .container-view {
      display: flex;
      flex-wrap: wrap;
      gap: 20px;

      .item {
        width: 203px;
        height: 280px;
        background-image: url(~@/assets/images/bottomitembg.png);
        background-size: 100% 100%;
        background-position: center;
        border-radius: 10px;
        font-size: 20px;
        font-weight: bold;
        color: #333;
        cursor: pointer;

        img {
          width: 183px;
          height: 110px;
          margin-left: 10px;
          margin-top: 50px;
        }

        .text {
          padding: 10px;
          height: 74px;

          p {
            margin: 0;
            font-size: 18px;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            display: -webkit-box;
            -webkit-box-orient: vertical;
          }
        }

        .more {
          padding: 10px;
          height: 30px;
          color: #0061ff;
          font-size: 16px;
          text-align: center;
        }
      }

    }
    .moreBtn {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        ::v-deep .el-button--primary {
          background-color: #00a1bb !important;
          border-color: #00a1bb !important;
        }
      }
  }
}

@media screen and (max-width: 767px) {
  .bg {
    background: url("");
    background-position: center;
    background-size: 100% 100%;
  }
  .part4 {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0px;
    align-items: center;
    .container {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 20px;
      margin-top: 20px;

      .container-view {
        justify-content: center;
       }

      .part-item-container {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/part4/Part4.vue